module.exports = __webpack_public_path__ + "static/img/logo_5.3fe106d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/logo_5.png
// module id = PHWT
// module chunks = 1